// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"834":"9ef08dbf2f2e3d17","928":"8af018d9bb53629a"}[chunkId] + ".js";
};